import React from "react";

import "react-select/dist/react-select.css";
import bestImg from "best.png";
import goodImg from "good.png";
import lookImg from "look.png";

class LevelCard extends React.Component {
  constructor(props) {
    super(props);
    this.recommendMaps = [
      "",
      {
        icon: lookImg,
        label: "可以观望",
        value: 1,
        checked: false,
      },
      {
        icon: goodImg,
        label: "值得一试",
        value: 2,
        checked: false,
      },
      {
        icon: bestImg,
        label: "力荐必试",
        value: 3,
        checked: false,
      },
    ];
  }

  componentDidMount() {}

  render() {
    const {
      item,
      isNothing = true,
      levelShow = !!item.level && item.level > 0,
      nothing = !item.level || item.level == 0,
      style,
      imgStyle,
    } = this.props;
    return (
      <>
        {levelShow && (
          <div className="level-card" style={style}>
            <img
              className={`${this.recommendMaps[item.level].value == 3 &&
                "level-card__img"}`}
              src={this.recommendMaps[item.level].icon}
              alt="zan"
              style={imgStyle}
            />
            {this.recommendMaps[item.level].label}
          </div>
        )}
        {isNothing && nothing && (
          <div className="level-card level-card--nothing" style={style}>
            暂无推荐
          </div>
        )}
      </>
    );
  }
}

export default LevelCard;
